import React, { PureComponent, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, Steps } from 'antd';

import Step1 from './applyClassly';
import Step2 from './applyUser';
import Step3 from './applyAudio';
const Step5 = function () {
  return (
    <div className="swite-result">
      <div className="bg">
        <i className="r-icon"></i>
        <p className="r-desc">您的大神入驻申请正在审核中...</p>
        <p className="r-reason">
          您的大神入驻申请已成功提交，我们会在3个工作日内审核您的申请，请耐心等待！
        </p>
      </div>
    </div>
  );
};
const Step6 = function () {
  return (
    <div className="swite-result">
      <div className="bg">
        <i className="r-icon"></i>
        <p className="r-desc">您的资质申请正在审核中...</p>
        <p className="r-reason">
          您的资质申请已成功提交，我们会在3个工作日内审核您的申请，请耐心等待！
        </p>
      </div>
    </div>
  );
};

const { Step } = Steps;
class ApplyDom extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      skillType: null,
      visible: false,
      step: null,
    };
  }
  showModal = (skillType = 1, step = 'step1') => {
    const { user } = this.props;
    let stepTo = 0;
    if (user.userBaseInfoVo?.ifGod == 1) {
      switch (step) {
        case 'step1':
          stepTo = 0;
          break;
        case 'step2':
          stepTo = 2;
          break;
        case 'step3':
          stepTo = 1;
          break;
        case 'step4':
          stepTo = 2;
          break;
        default:
          stepTo = 0;
          break;
      }
    } else {
      switch (step) {
        case 'step1':
          stepTo = 0;
          break;
        case 'step2':
          stepTo = 1;
          break;
        case 'step3':
          stepTo = 2;
          break;
        case 'step4':
          stepTo = 3;
          break;
        default:
          stepTo = 0;
          break;
      }
    }
    this.setState({ skillType, step: stepTo, visible: true });
  };
  hideModal = () => {
    this.setState({ visible: false });
    this.props.refresh && this.props.refresh();
  };
  nextStep = () => {
    const { user, refresh } = this.props;
    const { step } = this.state;
    let new_step = step + 1;
    //二次 考试
    if (new_step == 1) {
      refresh((applyProgress) => {
        //已学习
        if (user.userBaseInfoVo?.ifGod == 1 && applyProgress.videoStudy == 1) {
          new_step = 2;
        }
        this.setState({ step: new_step });
      });
    }
    //首次 考试
    if (new_step == 2) {
      refresh((applyProgress) => {
        if (user.userBaseInfoVo?.ifGod != 1) {
          //已学习
          if (applyProgress.videoStudy == 1) {
            new_step = 3;
          }
        }
        this.setState({ step: new_step });
      });
    } else {
      this.setState({ step: new_step });
    }
  };
  render() {
    const { visible, step, skillType } = this.state;
    const { base, user, categoryId, skillName } = this.props;
    if (!skillType) return null;
    if (user.userBaseInfoVo?.ifGod == 1) {
      return (
        <Fragment>
          <Modal
            open={visible}
            width="980px"
            wrapClassName="daidai-modal-style has-top-border"
            centered={true}
            title={'请选择需要申请的技能'}
            footer={null}
            keyboard={false}
            maskClosable={false}
            destroyOnHidden={true}
            onCancel={this.hideModal}
          >
            <div className="god-enter-modal-3">
              <div className="step-title">
                <Steps current={step} labelPlacement="vertical">
                  <Step title="技能资料" />
                  <Step title="视频学习" />
                  <Step title="平台审核" />
                </Steps>
              </div>
              <div style={{ height: '600px' }}>
                {step == 0 ? (
                  <Step1
                    nextEvent={this.nextStep}
                    base={base}
                    skillType={skillType}
                    skillName={skillName}
                    categoryId={categoryId}
                  />
                ) : null}
                {step == 1 ? (
                  <Step3
                    nextEvent={this.nextStep}
                    base={base}
                    skillType={skillType}
                  />
                ) : null}
                {step == 2 ? <Step6 /> : null}
              </div>
            </div>
          </Modal>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <Modal
          open={visible}
          width="980px"
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={'请选择需要申请的技能'}
          footer={null}
          keyboard={false}
          maskClosable={false}
          destroyOnHidden={true}
          onCancel={this.hideModal}
        >
          <div className="god-enter-modal-3">
            <div className="step-title">
              <Steps current={step} labelPlacement="vertical">
                <Step title="技能资料" />
                <Step title="个人资料" />
                <Step title="视频学习" />
                <Step title="平台审核" />
              </Steps>
            </div>
            <div style={{ height: '600px' }}>
              {step == 0 ? (
                <Step1
                  nextEvent={this.nextStep}
                  base={base}
                  skillType={skillType}
                  skillName={skillName}
                  categoryId={categoryId}
                />
              ) : null}
              {step == 1 ? (
                <Step2 nextEvent={this.nextStep} base={base} />
              ) : null}
              {step == 2 ? (
                <Step3
                  nextEvent={this.nextStep}
                  base={base}
                  skillType={skillType}
                />
              ) : null}
              {step == 3 ? <Step5 /> : null}
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(ApplyDom, { withRef: true });
